// Version : 1.0.0
// Author : AGALYA
import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** ADD CREDIT CHECK MEMBER START *********************** */
export const creditCheckMemberAdd = (verifyData: any) => {
	const data = {
		CreateCreditCheckMemberToken: verifyData,
	};
	const url = `${API_URL}addCreditCheckMember`;
	return makeApiCall(url, data);
};
/** ***************** ADD CREDIT CHECK MEMBER END *********************** */

/** ***************** GET CREDIT CHECK START *********************** */
export const getCreditCheck = (memberData: any) => {
	const data = {
		CheckMemberHighMarkToken: memberData,
	};
	const url = `${API_URL}callHighMark`;
	return makeApiCall(url, data);
};
/** ***************** GET CREDIT CHECK END *********************** */

/** ***************** GET EQUIFAX CHECK START *********************** */
export const getEquifaxCheck = (memberData: any) => {
	const data = {
		AppUploadEquifaxToken: memberData,
	};
	const url = `${API_URL}uploadEquifaxDetailsApp`;
	return makeApiCall(url, data);
};
/** ***************** GET EQUIFAX CHECK END *********************** */

/** ***************** VERIFY MEMBER START *********************** */
export const callVerifyMemberAPI = (memberData: any) => {
	const data = {
		CheckMemberDetailsToken: memberData,
	};
	const url = `${API_URL}checkMemberDetailsExistApp`;
	return makeApiCall(url, data);
};
/** ***************** VERIFY MEMBER END *********************** */

/** ***************** SEND OTP VERIFICATION CODE START *********************** */
export const otpVerificationCodeSend = (verifyData: any) => {
	const data = {
		HigmarkSendOtpVerify: verifyData,
	};
	const url = `${API_URL}sendVerificationOtp`;
	return makeApiCall(url, data);
};
/** ***************** SEND OTP VERIFICATION CODE END *********************** */

/** ***************** VERIFY CREDIT CHECK AADHAR OTP START *********************** */
export const verifyCreditCheckAadharOtpAPI = (credentials: any, serviceName: string) => {
	const data = {
		AadharOtpVerificationToken: credentials,
	};
	const url = `${API_URL + serviceName}`;
	return makeApiCall(url, data);
};
/** ***************** VERIFY CREDIT CHECK AADHAR OTP END *********************** */

/** ***************** VERIFY VALIDATE CREDIT CHECK AADHAR OTP START *********************** */
export const verifyValidateCreditCheckAadharOtpAPI = (credentials: any, serviceName: string) => {
	const data = {
		AadharValidateOtpVerificationToken: credentials,
	};
	const url = `${API_URL + serviceName}`;
	return makeApiCall(url, data);
};
/** ***************** VERIFY VALIDATE CREDIT CHECK AADHAR OTP END *********************** */

/** ***************** RECHECK MEMBER DETAILS FOR CRIF START *********************** */
export const callVerifyMemberDetailsAPI = (memberData: any) => {
	const data = {
		RecheckMemberCreditToken: memberData,
	};
	const url = `${API_URL}crifRecheckMemberDetails`;
	return makeApiCall(url, data);
};
/** ***************** RECHECK MEMBER DETAILS FOR CRIF END *********************** */
